// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__cc3bed9696b06dbd540a","cls2":"BulkFollowSuggestion-cls2___3c272c88b124bd91dcd BulkFollowSuggestion-cls1__cc3bed9696b06dbd540a"};